"use strict";
(self["webpackChunklittle_sleepies"] = self["webpackChunklittle_sleepies"] || []).push([[5224,9401],{

/***/ 5224:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ shopTheLook)
/* harmony export */ });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4692);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var swiper_bundle__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1732);
/* harmony import */ var _utilities_swiper_accessibility__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9401);




function shopTheLook() {
  ;(function init() {
    initSliders()
    openBIS()
  })()

  function initSliders() {
    const pdpHeroImages = jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-js-pdp-hero-images-v2]')
    pdpHeroImages.each((index, swiperContainer) => {
      const swiper = new swiper_bundle__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A(swiperContainer, {
        slidesPerView: 1,
        spaceBetween: 4,
        navigation: {
          nextEl: '[data-pdp-swiper-next]',
          prevEl: '[data-pdp-swiper-prev]',
        },
        breakpoints: {
          1024: {
            slidesPerView: 2,
            spaceBetween: 16,
            grid: {
              rows: 5,
              fill: 'row',
            },
          },
        },
      })
      
      // Add accessibility
      ;(0,_utilities_swiper_accessibility__WEBPACK_IMPORTED_MODULE_2__.addSwiperAccessibility)(swiper)
    })

    jquery__WEBPACK_IMPORTED_MODULE_0___default()(window).on('load', () => {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()('.shop-the-look-next').each((index, nextBtn) => {
        if (jquery__WEBPACK_IMPORTED_MODULE_0___default()(nextBtn).hasClass('swiper-button-disabled')) {
          jquery__WEBPACK_IMPORTED_MODULE_0___default()(nextBtn).removeClass('swiper-button-disabled')
          jquery__WEBPACK_IMPORTED_MODULE_0___default()(nextBtn).prop('disabled', false)
          jquery__WEBPACK_IMPORTED_MODULE_0___default()(nextBtn).prop('aria-disabled', false)
          jquery__WEBPACK_IMPORTED_MODULE_0___default()(nextBtn).siblings('.shop-the-look-prev').addClass('swiper-button-disabled')
          jquery__WEBPACK_IMPORTED_MODULE_0___default()(nextBtn).siblings('.shop-the-look-prev').prop('disabled', true)
          jquery__WEBPACK_IMPORTED_MODULE_0___default()(nextBtn).siblings('.shop-the-look-prev').prop('aria-disabled', true)
        }
      })
    })
  }

  function checkForBIS(callback) {
    if (window.BIS) {
      callback()
      return
    }
    setTimeout(checkForBIS, 100)
  }

  function openBIS() {
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(window).on('load', function () {
      let currentUrl = new URL(location)
      if (currentUrl.searchParams.has('open_bis') && jquery__WEBPACK_IMPORTED_MODULE_0___default()('#BIS_trigger').length) {
        checkForBIS(function () {
          if (jquery__WEBPACK_IMPORTED_MODULE_0___default()('#BIS_frame').length) {
            BIS.popup.show()
          } else {
            setTimeout(openBIS, 100)
          }
        })
      }
    })
  }
}


/***/ }),

/***/ 9401:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   addSwiperAccessibility: () => (/* binding */ addSwiperAccessibility)
/* harmony export */ });
// utility to add accessibility attributes to swiper slides
function addSwiperAccessibility(swiper) {
  const container = swiper.el
  let intersectionObserver = null
  
  // Function to update slide accessibility
  function updateSlideAccessibility() {
    const slides = container.querySelectorAll('.swiper-slide')
    
    // Stop observing all slides first
    slides.forEach((slide) => {
      if (intersectionObserver) {
        intersectionObserver.unobserve(slide)
      }
    })

    // Start observing all slides
    slides.forEach((slide) => {
      if (intersectionObserver) {
        intersectionObserver.observe(slide)
      }
    })

  }
  
  // Create intersection observer to track slide visibility
  intersectionObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const slide = entry.target
        const isVisible = entry.isIntersecting

        if (isVisible) {
          // Slide is visible - remove aria-hidden and tabindex, restore inner elements
          slide.removeAttribute('aria-hidden')
          slide.removeAttribute('tabindex')
          restoreTabbableElements(slide)
        } else {
          // Slide is not visible - add aria-hidden and tabindex="-1", disable inner elements
          slide.setAttribute('aria-hidden', 'true')
          slide.setAttribute('tabindex', '-1')
          disableTabbableElements(slide)
        }
      })
    },
    {
      root: container,
      rootMargin: '0px',
      threshold: 0.1, // Trigger when 10% of the slide is visible
    }
  )
  
  // Function to disable tabbable elements in hidden slides
  function disableTabbableElements(slide) {
    const tabbableElements = slide.querySelectorAll(
      'button, a, input, select, textarea, [tabindex]:not([tabindex="-1"])'
    )
    
    tabbableElements.forEach((element) => {
      if (element.hasAttribute('tabindex')) {
        element.setAttribute('data-original-tabindex', element.getAttribute('tabindex'))
      }
      element.setAttribute('tabindex', '-1')
    })
  }
  
  // Function to restore tabbable elements in visible slides
  function restoreTabbableElements(slide) {
    if (slide.getAttribute('aria-hidden') === 'true') {
      return
    }
    
    const tabbableElements = slide.querySelectorAll('[tabindex="-1"]')
    
    tabbableElements.forEach((element) => {
      if (element.hasAttribute('data-original-tabindex')) {
        const originalTabindex = element.getAttribute('data-original-tabindex')
        if (originalTabindex !== '-1') {
          element.setAttribute('tabindex', originalTabindex)
        } else {
          element.removeAttribute('tabindex')
        }
        element.removeAttribute('data-original-tabindex')
      } else {
        element.removeAttribute('tabindex')
      }
    })
  }
  
  setTimeout(() => {
    updateSlideAccessibility()
  }, 100)
  
  // Update on slide change
  swiper.on('activeIndexChange', function () {
    updateSlideAccessibility()
  })
}


/***/ })

}]);